/*
 * File: index.tsx
 * Desc: 可编辑表格输入组件
 * File Created: 2019-12-05 17:10:58
 * Author: chenghao at <hao.cheng@karakal.com.cn>
 * ------
 * Copyright 2019 - present, karakal
 */
import React, { useState, useEffect } from 'react';
import { Input } from 'antd';

interface TdInputRenderProps {
    style?: React.CSSProperties;
    className?: string;
    value?: any;
    onChange?: (value: any) => void;
    validator?: (value: any) => boolean;
    inputProps?: any;
    [key: string]: any;
}

/** 可编辑表格输入组件 */
const TdInputRender = (props: TdInputRenderProps) => {
    const { validator, style, ...rest } = props;
    const [value, setValue] = useState(props.value);

    useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    function onChange(inputValue: any) {
        if (validator && !validator(inputValue)) {
            return;
        }
        setValue(inputValue);
        props.onChange && props.onChange(inputValue);
    }

    return (
        <Input
            value={value}
            style={{ width: 100, ...style }}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                e.persist();
                onChange(e.target.value);
            }}
            {...rest}
        />
    );
};

export default TdInputRender;
